import Vue from "vue";
import VueRouter from "vue-router";
import { WalletList } from "@/utils/connect";
import { tryConnect, disconnectWallet } from "@/init";
import { isApp } from "@/utils/helper";
import { markets, aggregationObj } from "@/aggregation"

import store from "@/store";
const { state } = store;

const Main = () => import("../pages/Main");

Vue.use(VueRouter);

let routes = [
  {
    path: "/",
    name: "main",
    redirect: '/hyperliquid'
    // component: Main,
  },
  {
    path: "/drift",
    name: "Drift",
    component: Main,
  },
  {
    path: "/hyperliquid",
    name: "Hyperliquid",
    component: Main,
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

async function getInitData (to) {
  let currentRoute = to
  state.platformList = markets.map(item => {
    return {
      name: item.name,
      chainCode: item.chainCode,
      icon: item.icon,
      hasOrderBook: item.hasOrderBook,
      defaultSymbol: item.defaultSymbol
    }
  })
  let platform = state.platformList.find(item => currentRoute.name == item.name)
  if (!platform) platform = state.platformList[1]

  state.platform = platform
  state.chainCode = platform.chainCode

  state.pairSymbol = currentRoute.query.symbol

  const account = localStorage.getItem(`${platform.name}_account`)
  if (account) state.account = account


  const wallet = localStorage.getItem(`${platform.name}_wallet`)
  if (wallet) state.wallet = wallet

  await aggregationObj.init(state.platform)

}

router.beforeEach(async (to, from, next) => {
  if (from.fullPath == '/') {
    await getInitData(to)
    const { wallet, account } = state;
    if (account) {
      const { code, connect } = wallet
        ? WalletList.find((item) => {
          return item.code === wallet;
        })
        : WalletList[0];
      state.account = ''
      tryConnect(code, connect);
    } else if (isApp()) {
      const { code, connect } = WalletList[0];
      state.account = ''
      tryConnect(code, connect);
    }
  }

  return next();
});

export default router;
